import { Navigate, Outlet } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authState } from '../recoil/authState';
import { Suspense } from 'react';

const MasterRoute = () => {
    const auth = useRecoilValue(authState);
    const isMaster = Number(auth?.user?.club_admin_level) === 10;

    // 레벨 10(CEO)이 아니면 URL 직접 입력으로 접근해도 화면 노출 없이 /home으로 이동
    if (!isMaster) {
        return <Navigate to="/home" replace />;
    }

    return (
        <Suspense>
            <Outlet />
        </Suspense>
    );
};

export default MasterRoute;
